import {
  approveJoinGroupRequests as publicApproveJoinGroupRequests,
  rejectJoinGroupRequests as publicRejectJoinGroupRequests,
  listJoinGroupRequests as publicListJoinGroupRequests,
  queryJoinGroupRequests as publicQueryJoinGroupRequests,
  typedQueryJoinGroupRequests as publicTypedQueryJoinGroupRequests,
} from './social-groups-v2-join-group-request-join-group-requests.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onJoinGroupRequestApproved as publicOnJoinGroupRequestApproved } from './social-groups-v2-join-group-request-join-group-requests.public.js';
import { onJoinGroupRequestCreated as publicOnJoinGroupRequestCreated } from './social-groups-v2-join-group-request-join-group-requests.public.js';
import { onJoinGroupRequestRejected as publicOnJoinGroupRequestRejected } from './social-groups-v2-join-group-request-join-group-requests.public.js';

export const approveJoinGroupRequests: MaybeContext<
  BuildRESTFunction<typeof publicApproveJoinGroupRequests> &
    typeof publicApproveJoinGroupRequests
> = /*#__PURE__*/ createRESTModule(publicApproveJoinGroupRequests);
export const rejectJoinGroupRequests: MaybeContext<
  BuildRESTFunction<typeof publicRejectJoinGroupRequests> &
    typeof publicRejectJoinGroupRequests
> = /*#__PURE__*/ createRESTModule(publicRejectJoinGroupRequests);
export const listJoinGroupRequests: MaybeContext<
  BuildRESTFunction<typeof publicListJoinGroupRequests> &
    typeof publicListJoinGroupRequests
> = /*#__PURE__*/ createRESTModule(publicListJoinGroupRequests);
export const queryJoinGroupRequests: MaybeContext<
  BuildRESTFunction<typeof publicQueryJoinGroupRequests> &
    typeof publicQueryJoinGroupRequests
> = /*#__PURE__*/ createRESTModule(publicQueryJoinGroupRequests);
export const typedQueryJoinGroupRequests: MaybeContext<
  BuildRESTFunction<typeof publicTypedQueryJoinGroupRequests> &
    typeof publicTypedQueryJoinGroupRequests
> = /*#__PURE__*/ createRESTModule(publicTypedQueryJoinGroupRequests);
/**
 * Triggered when a join group request is approved.
 */
export const onJoinGroupRequestApproved: BuildEventDefinition<
  typeof publicOnJoinGroupRequestApproved
> &
  typeof publicOnJoinGroupRequestApproved = createEventModule(
  publicOnJoinGroupRequestApproved
);
/** */
export const onJoinGroupRequestCreated: BuildEventDefinition<
  typeof publicOnJoinGroupRequestCreated
> &
  typeof publicOnJoinGroupRequestCreated = createEventModule(
  publicOnJoinGroupRequestCreated
);
/**
 * Triggered when a join group request is rejected.
 */
export const onJoinGroupRequestRejected: BuildEventDefinition<
  typeof publicOnJoinGroupRequestRejected
> &
  typeof publicOnJoinGroupRequestRejected = createEventModule(
  publicOnJoinGroupRequestRejected
);

export {
  RequestStatus,
  ViolationType,
  ItemsToUpdate,
  OwnershipFilter,
  SortOrder,
  WebhookIdentityType,
} from './social-groups-v2-join-group-request-join-group-requests.universal.js';
export {
  JoinGroupRequest,
  RequestDetails,
  SocialGroupsEvent,
  SocialGroupsEventPayloadOneOf,
  MemberJoinedGroup,
  MembersAddedToGroup,
  JoinRequestsApproved,
  MembersInvitedToGroup,
  GetJoinRequirementsRequest,
  MembershipQuestionAnswer,
  GetJoinRequirementsResponse,
  PaidPlan,
  EventsViolationOptions,
  PricingPlanViolationOptions,
  MembershipQuestionViolationOptions,
  Violation,
  ViolationViolationOptionsOneOf,
  SubmitJoinGroupRequestRequest,
  SubmitJoinGroupRequestResponse,
  CancelJoinGroupRequestRequest,
  CancelJoinGroupRequestResponse,
  JoinGroupRequestCancelled,
  ApproveJoinGroupRequestsRequest,
  ApproveJoinGroupRequestsResponse,
  JoinGroupRequestApproved,
  RejectJoinGroupRequestsRequest,
  Rejection,
  RejectJoinGroupRequestsResponse,
  JoinGroupRequestRejected,
  ListJoinGroupRequestsRequest,
  ListJoinGroupRequestsResponse,
  PagingMetadata,
  QueryJoinGroupRequestsRequest,
  Query,
  Sorting,
  Paging,
  QueryJoinGroupRequestsResponse,
  RejectAllJoinGroupRequestsRequest,
  RejectAllJoinGroupRequestsResponse,
  ApproveAllJoinGroupRequestsRequest,
  ApproveAllJoinGroupRequestsResponse,
  ListAllJoinGroupRequestsRequest,
  ListAllJoinGroupRequestsResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  JoinGroupRequestApprovedEnvelope,
  JoinGroupRequestCreatedEnvelope,
  JoinGroupRequestRejectedEnvelope,
  ListJoinGroupRequestsOptions,
  QueryJoinGroupRequestsOptions,
  JoinGroupRequestsQueryResult,
  JoinGroupRequestsQueryBuilder,
  JoinGroupRequestQuerySpec,
} from './social-groups-v2-join-group-request-join-group-requests.universal.js';
export { utils } from './social-groups-v2-join-group-request-join-group-requests.universal.js';
export {
  RequestStatusWithLiterals,
  ViolationTypeWithLiterals,
  ItemsToUpdateWithLiterals,
  OwnershipFilterWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CommonQueryWithEntityContext,
  JoinGroupRequestQuery,
} from './social-groups-v2-join-group-request-join-group-requests.universal.js';
